import { Component, HostListener, Input } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';

@Component({
  selector: 'app-culture-score-details',
  templateUrl: './culture-score-details.component.html',
  styleUrl: './culture-score-details.component.scss',
})
export class CultureScoreDetailsComponent extends BaseComponent {
  @Input() progressBarColorString: string = '';
  @Input() cultureScore: number = 0; // 0-100
  @Input() isLoading: boolean = true;
  // progressBarWidth: string = '';

  constructor() {
    super();
  }

  ngOnInit(): void {
    // this.calculateProgressBarWidth();
  }

  // calculateProgressBarWidth(): void {
    // if (window.innerWidth > 580) {
    //   this.progressBarWidth = '170px';
    // } else if (window.innerWidth > 500) {
    //   this.progressBarWidth = '150px';
    // } else if (window.innerWidth > 420) {
    //   this.progressBarWidth = '130px';
    // } else if (window.innerWidth > 380) {
    //   this.progressBarWidth = '115px';
    // } else {
    //   this.progressBarWidth = '90px';
    // }
    // this.progressBarWidth='60%'
  // }
  // if window width changes, update progress bar width
  // @HostListener('window:resize', ['$event']) onResize(event: any) {
  //   this.calculateProgressBarWidth();
  // }
}
